import React from "react";
const Error = () => {
	return (
		<div className='section'>
			<h2 className='section-center'>An Error has Occurred</h2>
		</div>
	);
};

export default Error;
